import axiosapi from "./axiosAPI";

// Get All Responses
export const getAllResponses = async (
    setResponses,
    setFetcherror,
    pkid,
    display,
    notification,
) => {
    
	try{
		const res =await axiosapi.get( display? `/responses?iid=${pkid} && display=${display}`:notification ? `/responses?iid=${pkid} && notification=${notification}`:`/responses?iid=${pkid}`);
        setResponses(res.data.data ? res.data.data : {});
        console.log("FINAL DATA", res.data.data);
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Responses");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Responses");
		}
		
	}
	
};


export const getSpecificResponses = async (
    setResponses,
    setFetcherror,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    isprocessed,
    isvalid,

) => {
    
    const page = ((event?.first)/(event?.rows))+1 || 1
    const limit = (event?.rows) || 10
    
    const options = {
        isprocessed,
        isvalid,
        page: page,
        limit:limit
    }
    
	try{
        const res = await axiosapi.post("/specificresponses", options);
        
        setResponses(res.data.data ? res.data.data : {});
        setTotalCount(res.data.totalCount);
        setIsLoading(false);
        setFirst(event? event?.first:0);
        setRows(event? event?.rows:10)

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response);
            setFetcherror("Error: Could Not Fetch Responses");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Responses");
		}
		
	}
	
};

// Responses table (paginated, includes incident snapshot + responder)
export const getResponsesTable = async (
    setResponses,
    setFetcherror,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    searchTerm = ""
) => {
    const page = ((event?.first) / (event?.rows)) + 1 || 1;
    const limit = (event?.rows) || 10;
    const search = searchTerm || "";

    try {
        const res = await axiosapi.get("/responses/table", { params: { page, limit, search } });
        setResponses(res?.data?.data?.rows || []);
        setTotalCount(res?.data?.data?.count || 0);
        setIsLoading(false);
        setFirst(event ? event?.first : 0);
        setRows(event ? event?.rows : 10);
    } catch (err) {
        if (err.response) {
            console.log(err.response);
            setFetcherror("Error: Could Not Fetch Responses");
        } else {
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Responses");
        }
        setIsLoading(false);
    }
};

export const exportResponsesTable = async (params, exportType = "pdf") => {
    const response = await axiosapi.get("/responses/table", {
        params: { ...params, exportReport: true, exportType },
        responseType: "blob"
    });

    const contentDisposition = response.headers["content-disposition"];
    let filename = `responses_${Date.now()}.${exportType}`;
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, "");
        }
    }

    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

// Responses report table (paginated with filters)
export const getResponsesReportTable = async (
    setResponses,
    setFetcherror,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    filters = {}
) => {
    const page = ((event?.first) / (event?.rows)) + 1 || 1;
    const limit = (event?.rows) || 10;

    try {
        const res = await axiosapi.get("/responses/table", {
            params: {
                page,
                limit,
                ...filters
            }
        });

        setResponses(res?.data?.data?.rows || []);
        setTotalCount(res?.data?.data?.count || 0);
        setIsLoading(false);
        setFirst(event ? event?.first : 0);
        setRows(event ? event?.rows : 10);
    } catch (err) {
        if (err.response) {
            console.log(err.response);
            setFetcherror("Error: Could Not Fetch Responses");
        } else {
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Responses");
        }
        setIsLoading(false);
    }
};



// Get One Response
export const getOneResponse = async (
    pkid,
    setFetcherror,  
    setResponse
    
)=>{
	try{
		const res =await axiosapi.get(`/responses/${pkid}`);
        setResponse(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Response");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Response");
		}
		
	}
	
};


// Create New Response
export const createResponse = async (
    content,
    setContent,
    fromName,
    selectedStatus,
    setSelectedStatus,
    user_id,
    incident_id,
    setFetcherror,
    handleAllToasts,
    setResponses,
    operatorinitiated

) => {


    if (!content || !fromName ||  !selectedStatus || !user_id || !incident_id ) {
        handleAllToasts(2, "No Response Provided"); 
            return; 
        }

    const getOptions = () => { 
        if (operatorinitiated) { 
            return {
                content,
                fromname: fromName,
                status: selectedStatus?.name,
                user_id,
                incident_id,
                isvalid: true,
                isprocessed:true
            }
        } 
        return {
                content,
                fromname: fromName,
                status: selectedStatus?.name,
                user_id,
                incident_id
                 }
    }



    try{
        await axiosapi.post("/responses/",getOptions());
        setContent("");
        setSelectedStatus("");
        handleAllToasts(1, "Response Created Successfully");
        getAllResponses(setResponses, setFetcherror,incident_id);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Response");
            handleAllToasts(2, "Could Not update The Response");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Response");
            handleAllToasts(2, "Could Not update The Response");
            
        }
        
    }
    
}


// Edit Existing Response

export const editResponse = async (
    responsepkid,
    fromName,
    user_id,
    incident_id,
    isvalid,
    isprocessed,
    setFetcherror,
    handleAllToasts,
    setResponses,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    setResponseValid,
    setViewDialogVisible,
    callback
              
        ) => {

            if (!responsepkid  || !(fromName || user_id || incident_id)) {
                handleAllToasts(2, "No Response selected or item changed"); 
                    return;  
                }

            const PushItem = {

                    id:responsepkid,
                    isvalid,
                    isprocessed,
                };

            try{
                await axiosapi.patch("/responses/",PushItem );
                handleAllToasts(1, "Response Updated Successfully");
                if (typeof callback === "function") callback(null, "Success");

                console.log("CLICKED HEEEEEEEEEE FYNCTION")
                setResponseValid(false);
                setViewDialogVisible(false);
                getSpecificResponses  (
                        setResponses,
                        setFetcherror,
                        setIsLoading,
                        setFirst,
                        setRows,
                        event,
                        setTotalCount,
                        false,
                        false
                    )
            }
            catch(err){
                    setFetcherror("Could Not Update Response");
                    handleAllToasts(2, "Could Not Update Response");
                    if (typeof callback === "function") callback(new Error("Could Not Update Response"), null);
                    
                
            }
            
};



// Delete Existing Response.

export const deleteResponse = async (
    responsepkid,
    setResponses,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/responses/${responsepkid}`);
        handleAllToasts(1, "Response Deleted Successfully");
        getAllResponses(setResponses, setFetcherror);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Response");
            handleAllToasts(2,"Error: Could Not Delete Response");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Response");
            handleAllToasts(2,"Error: Could Not Delete Response");
		}
		
	}
	
};